import type { Moment } from 'moment';

export const validateEnrollmentTimeRange = (args: {
  isStartTime: boolean;
  startTime: Moment | undefined | null;
  endTime: Moment | undefined | null;
}) => {
  const { isStartTime, startTime, endTime } = args;

  if ((isStartTime && !startTime) || (!isStartTime && !endTime)) {
    return Promise.reject('必填欄位');
  }
  if (startTime && endTime && endTime.isSameOrBefore(startTime, 'minute')) {
    return Promise.reject('截止時間需晚於起始時間');
  }
  return Promise.resolve();
};

export const validateEnrollmentNumbers = (args: {
  isMinimum: boolean;
  maximumEnrollment: number | undefined | null;
  minimumEnrollment: number | undefined | null;
}) => {
  const { isMinimum, maximumEnrollment, minimumEnrollment } = args;

  if ((isMinimum && !minimumEnrollment) || (!isMinimum && !maximumEnrollment)) {
    return Promise.reject('必填欄位');
  }
  if (
    maximumEnrollment &&
    minimumEnrollment &&
    maximumEnrollment < minimumEnrollment
  ) {
    return Promise.reject('上限人數不得低於最低人數');
  }
  return Promise.resolve();
};
